var chunkToChildrenMap = {
	"1911": [
		5450,
		6773,
		7488
	],
	"3773": [
		9586,
		6601,
		4257,
		4810,
		2343,
		586
	],
	"8894": [
		9586,
		6601,
		4257,
		4810,
		2343
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));